import { render, staticRenderFns } from "./potions.vue?vue&type=template&id=85dada7c&scoped=true&"
import script from "./potions.vue?vue&type=script&lang=js&"
export * from "./potions.vue?vue&type=script&lang=js&"
import style0 from "./potions.vue?vue&type=style&index=0&id=85dada7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dada7c",
  null
  
)

export default component.exports